// extracted by mini-css-extract-plugin
module.exports = {"root":"AgritourismStatutes_root__3-x1y","anchor":"AgritourismStatutes_anchor__2XtOH","agriLink":"AgritourismStatutes_agriLink__2x2Ay"};